// extracted by mini-css-extract-plugin
export var finish = "style-module--finish--3QseT";
export var finish_head_suptitle = "style-module--finish_head_suptitle--2ECfC";
export var finish_head_title = "style-module--finish_head_title--1zbJP";
export var finish_main = "style-module--finish_main--2MsSS";
export var finish_main_title = "style-module--finish_main_title--3RXQM";
export var finish_main_links = "style-module--finish_main_links--eOZCt";
export var finish_bot = "style-module--finish_bot--1Jy5r";
export var finish_bot_title = "style-module--finish_bot_title--3UYn9";
export var finish_bot_desc = "style-module--finish_bot_desc--13mCn";
export var largelink = "style-module--largelink--2qelJ";
export var largelink_arrow = "style-module--largelink_arrow--Va1Z0";
export var largelink_l = "style-module--largelink_l--95sHb";
export var largelink_r = "style-module--largelink_r--3W2Wk";
export var largelink_title = "style-module--largelink_title--3K94e";